module.exports = __webpack_public_path__ + "img/receipt4.2c151e3c.png";